import { render } from "./InvitationProfileinfo.vue?vue&type=template&id=5984824f"
import script from "./InvitationProfileinfo.vue?vue&type=script&lang=js"
export * from "./InvitationProfileinfo.vue?vue&type=script&lang=js"

import "./InvitationProfileinfo.vue?vue&type=style&index=0&id=5984824f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__